import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { WidgetComponent } from '..';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { StoreService } from 'core/services';
import { ChartDataset } from 'chart.js';

@Component({
  selector: 'lms-licenses-totals-widget',
  templateUrl: './licenses-totals-widget.component.html',
  styleUrls: ['./licenses-totals-widget.component.scss']
})
export class LicensesTotalsWidgetComponent implements WidgetComponent, OnInit, OnDestroy {
  @Input() totals: any;
  @Input() data: any;
  @Input() hasTitle: boolean;
  @Input() key?: string;

  public completedRatio: number;
  public licenseStatusKeys = ['created', 'playing', 'completed'];
  public legendColors: any[] = ['color-game-16', 'color-game-12', 'color-game-8'];
  public canvasData: ChartDataset[] | any[];
  public tooltipLabels: string[] = ['created', 'playing', 'completed'];
  public chartColors: { backgroundColor: string[] } = {
    backgroundColor: ['#dae0e5', '#66b2ff', '#007eff']
  };
  public chartOptions = { height: 150 };
  public tooltipText: string;
  private tooltipSubscription: Subscription = new Subscription();

  constructor(public translateService: TranslateService) {}

  ngOnInit(): void {
    if (this.totals && this.totals.total) {
      this.tooltipLabels = this.licenseStatusKeys.map(
        (key) => `${key} (${Math.round((this.totals[key] / this.totals.total) * 100)}%)`
      );
      this.completedRatio = Math.round((this.totals.completed / this.totals.total) * 100);
      this.canvasData = [this.totals.created, this.totals.beforeDemo + this.totals.afterDemo, this.totals.completed];
    }

    this.tooltipLabels = [
      this.translateService.instant('groups.dashboard.legend.created'),
      this.translateService.instant('groups.dashboard.legend.playing'),
      this.translateService.instant('groups.dashboard.legend.completed')
    ];

    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipText) => {
      this.tooltipText = tooltipText[this.key];
    });
  }

  ngOnDestroy(): void {
    this.tooltipSubscription.unsubscribe();
  }
}
